module.exports = __webpack_public_path__ + "assets/img/jiguangliduyi.4dd07964.jpg";